import axios from "axios";
import Config from "@/config"

export default class FormService {
    async createUser(data) {
        const options = {
            headers: {
                ...Config.headers(),
                "Content-Type": "application/json"
            },
        };
        return await axios
            .post(
                Config.proxy + Config.url("createUser"),
                data,
                options,
            )
            .then(res => res.data)
            .catch( () => null
            )
    }
    async modifyUser(id,data) {
        const options = {
            headers: {
                ...Config.headers(),
                "Content-Type": "application/json"
            },
        };
        return await axios
            .put(
                Config.proxy + Config.url("createUser")+"/"+id,
                data,
                options,
            )
            .then(res => res.data);
    }
    async getUser(id) {
        const options = {
            headers: {
                ...Config.headers(),
                "Content-Type": "application/json"
            },
            params: {
            "populate": "owned_connected_appliances,wish_connected_appliances,liked_recipes,ingredients_allergies,recent_recipes,not_liked_ingredients,liked_ingredients,liked_recipes.category,ingredients_allergies.labels,not_liked_ingredients.labels,liked_ingredients.labels,recent_recipes.labels,recent_recipes.media,liked_recipes.labels,liked_recipes.media",
            }
        };
        return await axios
            .get(
                Config.proxy + Config.url("createUser")+"/"+id,
                options,
            )
            .then(res => res.data)
            .catch( () => null
            )
    }
}
